import { useContext, useState } from "react"
import { authorizerService } from "services/middleware_services"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import { Env, MultiClient } from "config"
import { SIMO_VAR } from "constants/APP_CONSTANTS"
import { logInAction, logOutAction } from "store/actions/publicActions"
import { useNavigate } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import useAuth0Credentials from "hooks/useAuth0Credentials"

interface IErrorLogin {
  code: number
  message: string
}

const useAuthorizer = () => {
  const { logout: logout_auth0 } = useAuth0()
  let [, _env] = MultiClient.get_user_env(null, Env.clients, Env.env, Env.defaults)
  const [error_login, set_error_login] = useState<IErrorLogin>({
    code: 0,
    message: "",
  })
  const { isCancel } = useCancelToken()
  const { dispatch } = useContext(AuthContext)
  const { set_loading_app } = useContext(AppContext)
  const navigate = useNavigate()
  const { clientId } = useAuth0Credentials()

  const login_user_action = async () => {
    try {
      set_loading_app(true)
      set_error_login({
        code: 0,
        message: "",
      })
      // Temporal handler
      const cred_dev = {
        audience: "https://omnixv4dev-middleware.omnixsystem.com",
        grant_type: "client_credentials",
        client_id: "uUoctM7Xmn6NsrquR1C4O8jIy161Ov6C",
        client_secret: "Fnh3rG4zRKxF89KxEq5mNNuHzrMJOXBmLrj_Nrb86D5s-HGQeHEwekScgJI7LfiT",
      }
      const cred_uat = {
        audience: "https://omnixv4uat-middleware.omnixsystem.com",
        grant_type: "client_credentials",
        client_id: "wN6y7n1dgKqSZlzS7AoncYrwncz3WtDj",
        client_secret: "e-KBQlRTbyb1IiBgHEM3eTNuak-vXQCBfhUVNE9tqBAxk8Ak2Guv4BBWYGFAQe9j",
      }
      const credentials = _env === "dev" ? cred_dev : cred_uat
      const responseLogin = await authorizerService(credentials)
      const {
        data: { access_token },
      } = responseLogin
      dispatch(logInAction({ id: "guest", name: "Invitado", role: "guest", email: "guest", token: access_token }))
      set_loading_app(false)
      navigate("/dashboard")
    } catch (error: any) {
      set_loading_app(false)
      set_error_login({
        code: error?.response?.status,
        message: error.response?.data?.message,
      })
      if (isCancel(error)) return
    }
  }

  const logout_user_action = () => {
    localStorage.removeItem(SIMO_VAR)
    dispatch(logOutAction)
    logout_auth0({ logoutParams: { returnTo: window.location.origin, client_id: clientId, federated: true } } as any)
    // navigate("/login");
    window.location.reload()
  }

  return {
    error_login,
    login_user_action,
    logout_user_action,
  }
}

export default useAuthorizer
